import script from "./AssertionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssertionModal.vue?vue&type=script&lang=ts&setup=true"

import "./AssertionModal.vue?vue&type=style&index=0&id=c53e75fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c53e75fa"]])

export default __exports__